import { render } from "./ResourceActions.vue?vue&type=template&id=50919b5e"
import script from "./ResourceActions.vue?vue&type=script&lang=js"
export * from "./ResourceActions.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__